export default __webpack_public_path__ + "static/media/error-email-verification.8224be87.png";